/*
 * Maison Avéla — live product total.
 *
 * Recalculates "Общо" from the selected variant, the quantity and any
 * ticked add-on (gift wrap) without touching the cart, so the number
 * updates instantly while the shopper is still deciding.
 */
(function () {
  'use strict';

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function formatMoney(cents, format) {
    var fmt = format && format.indexOf('{{') !== -1 ? format : '{{amount_with_comma_separator}} €';
    var match = fmt.match(PLACEHOLDER);
    var name = match ? match[1] : 'amount';

    var precision = 2;
    var thousands = ',';
    var decimal = '.';

    switch (name) {
      case 'amount_no_decimals':
        precision = 0;
        break;
      case 'amount_with_comma_separator':
        thousands = '.';
        decimal = ',';
        break;
      case 'amount_no_decimals_with_comma_separator':
        precision = 0;
        thousands = '.';
        decimal = ',';
        break;
      case 'amount_with_apostrophe_separator':
        thousands = "'";
        break;
      case 'amount_with_space_separator':
        thousands = ' ';
        decimal = ',';
        break;
      case 'amount_no_decimals_with_space_separator':
        precision = 0;
        thousands = ' ';
        break;
      default:
        break;
    }

    var value = (Math.round(cents) / 100).toFixed(precision);
    var parts = value.split('.');
    var head = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var tail = parts[1] ? decimal + parts[1] : '';

    return fmt.replace(PLACEHOLDER, head + tail);
  }

  function readPrices(root) {
    var script = root.querySelector('[data-ma-total-prices]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function scopeOf(el) {
    return el.closest('.shopify-section') || el.closest('product-information') || document;
  }

  function currentVariantId(scope) {
    var input =
      scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      scope.querySelector('input[name="id"]');
    return input ? String(input.value || '').trim() : '';
  }

  function currentQuantity(scope) {
    var input =
      scope.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"]') ||
      scope.querySelector('[ref="quantityInput"]');
    var value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function update(el) {
    var scope = scopeOf(el);
    var prices = el.__maPrices || (el.__maPrices = readPrices(el));
    var format = el.getAttribute('data-money-format');

    var id = currentVariantId(scope);
    var unit = Object.prototype.hasOwnProperty.call(prices, id) ? prices[id] : null;

    if (unit === null) {
      var ids = Object.keys(prices);
      if (!ids.length) return;
      unit = prices[ids[0]];
    }

    var qty = currentQuantity(scope);
    var total = unit * qty;

    var noteParts = [];
    if (qty > 1) {
      noteParts.push(qty + ' × ' + formatMoney(unit, format));
    }

    var wrapToggle = scope.querySelector('[data-gift-wrap-toggle]');
    var wrapPrice = parseInt(el.getAttribute('data-wrap-price'), 10);
    if (wrapToggle && wrapToggle.checked && !isNaN(wrapPrice)) {
      total += wrapPrice;
      noteParts.push(
        (el.getAttribute('data-wrap-label') || 'Добавка') + ' + ' + formatMoney(wrapPrice, format)
      );
    }

    var valueEl = el.querySelector('[data-ma-total-value]');
    var nextValue = formatMoney(total, format);
    if (valueEl && valueEl.textContent.trim() !== nextValue) {
      valueEl.textContent = nextValue;
    }

    var noteEl = el.querySelector('[data-ma-total-note]');
    var nextNote = noteParts.join(' · ');
    if (noteEl && noteEl.textContent.trim() !== nextNote) {
      noteEl.textContent = nextNote;
    }
  }

  var frame = null;
  function updateAll() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      document.querySelectorAll('[data-ma-total]').forEach(function (el) {
        update(el);
      });
    });
  }

  ['change', 'input', 'quantity-selector:update', 'variant:update', 'variantUpdate'].forEach(
    function (name) {
      document.addEventListener(name, updateAll, true);
    }
  );

  function observe() {
    document.querySelectorAll('[data-ma-total]').forEach(function (el) {
      if (el.__maObserved) return;
      el.__maObserved = true;

      var scope = scopeOf(el);
      if (scope === document) return;

      var observer = new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var target = records[i].target;
          if (target && target.nodeType === 1 && target.closest('[data-ma-total]')) continue;
          updateAll();
          return;
        }
      });

      observer.observe(scope, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['value', 'data-variant-id', 'disabled'],
      });
    });
  }

  function boot() {
    // The price map is rendered fresh with the section, so drop the cache.
    document.querySelectorAll('[data-ma-total]').forEach(function (el) {
      el.__maPrices = readPrices(el);
    });
    observe();
    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', boot);
})();